import { Modal, StyleSheet, Text, View } from 'react-native';
import { getResponsiveSize } from 'utils/index';

import { AccountNotFoundModalProps } from 'components/AccountDeactivated/AccountNotFoundModal';
import {
  ACCOUNT_NOT_FOUND_BUTTON,
  ACCOUNT_NOT_FOUND_MESSAGE,
  ACCOUNT_NOT_FOUND_TITLE,
} from 'components/AccountDeactivated/AccountNotFoundModal/constants';
import NewGradientButton from 'components/Button/NewGradienteButton';

export const WebAccountNotFoundModal = ({
  isOpen,
  onClose,
}: AccountNotFoundModalProps): React.ReactNode => {
  if (!isOpen) return null;

  return (
    <Modal visible={isOpen} transparent animationType="fade" onRequestClose={onClose}>
      <View style={styles.overlay}>
        <View style={styles.container}>
          <Text style={styles.title}>{ACCOUNT_NOT_FOUND_TITLE}</Text>

          <Text style={styles.text}>{ACCOUNT_NOT_FOUND_MESSAGE}</Text>

          <View style={styles.buttonContainer}>
            <NewGradientButton height={54} onPress={onClose} width="$full">
              <Text style={styles.buttonText}>{ACCOUNT_NOT_FOUND_BUTTON}</Text>
            </NewGradientButton>
          </View>
        </View>
      </View>
    </Modal>
  );
};

const styles = StyleSheet.create({
  overlay: {
    width: '100%',
    height: '100%',
    backgroundColor: 'rgba(0,0,0,0.85)',
    justifyContent: 'center',
    alignItems: 'center',
  },
  container: {
    width: '90%',
    maxWidth: 480,
    padding: Number(getResponsiveSize({ base: 24, md: 40 })),
    backgroundColor: '#050923',
    borderRadius: 16,
    borderWidth: 1,
    borderColor: '#182DB3',
  },
  title: {
    fontSize: Number(getResponsiveSize({ base: 22, md: 28 })),
    fontWeight: '700',
    color: '#7A8CFF',
    textAlign: 'center',
    marginBottom: 16,
  },
  text: {
    color: '#FFF',
    fontSize: Number(getResponsiveSize({ base: 16, md: 18 })),
    lineHeight: Number(getResponsiveSize({ base: 24, md: 26 })),
    textAlign: 'center',
  },
  buttonContainer: {
    width: '100%',
    marginTop: Number(getResponsiveSize({ base: 24, md: 32 })),
  },
  buttonText: {
    textAlign: 'center',
    fontWeight: 'bold',
    color: '#070d31',
    fontSize: 16,
  },
});
